import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FormControl, FormControlLabel, Radio, RadioGroup } from '../atom'

const Wrapper = styled.div`
  display: flex;
  border-radius: 4px;
  gap: 12px;
`
const OptionWrapper = styled.div`
  display: flex;
  padding-left: 27px;
  align-items: flex-start;
  gap: 6px;
`
const OptionBox = styled.button`
  display: flex;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 0.5px solid var(--gray50, #b3b3b3);
  background: var(--gray10, #fff);
  cursor: pointer;

  &.active {
    background-color: #57c9a7;
    border-color: #57c9a7;
  }

  &:hover:not(.active) {
    background-color: #f0f0f0;
    border-color: #a3a3a3;
  }
`
const OptionText = styled.div`
  color: var(--gray70, #666);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  ${OptionBox}.active & {
    color: #fff;
  }
`

interface IList {
  label: string
}

interface Props {
  list?: IList[]
  value?: any
  onChange?: (selectedValue: string) => void
  patternData?: string
  keyName: string
  setData?: any
  setRadioValue?: any
}

const ColumnRadioWith3M = (props: Props) => {
  const {
    value,
    list,
    onChange,
    patternData,
    keyName,
    setData,
    setRadioValue,
  } = props
  const [selectedValue, setSelectedValue] = useState('0')
  const [selectedPatternValue, setSelectedPatternValue] = useState('')
  const PatternList = ['평균값', '중간값', '최빈값']

  useEffect(() => {
    if (patternData === 'realTime') {
      setSelectedPatternValue('')
      return
    }

    if (patternData) {
      switch (patternData) {
        case 'mid':
          setSelectedPatternValue('중간값')
          break

        case 'mode':
          setSelectedPatternValue('최빈값')
          break

        case 'aver':
        default:
          setSelectedPatternValue('평균값')
          break
      }
    }
  }, [patternData])

  useEffect(() => {
    if (value) setSelectedValue(value)
  }, [value])

  const handleRadioButton = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value

    setSelectedValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  useEffect(() => {
    if (selectedValue === '0') {
      setSelectedPatternValue('')
    }
  }, [selectedValue])

  const handlePatternButton = async (item: string) => {
    await setRadioValue('1')

    switch (item) {
      case '중간값':
        setSelectedPatternValue('중간값')
        setData((prev: any) => {
          const updatedDataUnit = { ...prev, [keyName]: 'mid' }
          return updatedDataUnit
        })
        break

      case '최빈값':
        setSelectedPatternValue('최빈값')
        setData((prev: any) => {
          const updatedDataUnit = { ...prev, [keyName]: 'mode' }
          return updatedDataUnit
        })
        break

      case '평균값':
      default:
        setSelectedPatternValue('평균값')
        setData((prev: any) => {
          const updatedDataUnit = { ...prev, [keyName]: 'aver' }
          return updatedDataUnit
        })
        break
    }
  }

  const controlProps = (item: string) => ({
    checked: selectedValue === item,
    onChange: () => handleRadioButton,
    value: item,
    name: 'color-radio-button',
    inputProps: { 'aria-label': item },
  })

  return (
    <Wrapper>
      <FormControl>
        <RadioGroup value={selectedValue} onChange={handleRadioButton}>
          {list?.map((item, index) => (
            <FormControlLabel
              control={
                <Radio
                  {...controlProps(`${index}`)}
                  sx={{
                    '&.Mui-checked': {
                      color: '#57C9A7',
                    },
                  }}
                  size="small"
                />
              }
              label={item.label}
            />
          ))}
        </RadioGroup>
        <OptionWrapper>
          {PatternList.map((item, index) => (
            <OptionBox
              key={index}
              value={selectedPatternValue}
              onClick={() => handlePatternButton(item)}
              className={selectedPatternValue === item ? 'active' : ''}
            >
              <OptionText>{item}</OptionText>
            </OptionBox>
          ))}
        </OptionWrapper>
      </FormControl>
    </Wrapper>
  )
}

export default ColumnRadioWith3M
